import { PropsWithChildren } from 'react'

export function FormLabel({ children }: PropsWithChildren) {
    return <label className="font-bold text-xs text-gray-500">{children}</label>
}
